var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center",attrs:{"id":"document-svg-icon"}},[_c('div',{ref:"DocumentSvgIcon",class:_vm.svgClasses})])
}
var staticRenderFns = []

export { render, staticRenderFns }